import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import {
    toggleModalDiagramRename,
    toggleModalDiagramClone,
    toggleModalDiagramSoftDelete,
    toggleModalDiagramDelete,
    toggleModalDiagramRestore,
    toggleModalDiagramShare,
    toggleDiagramDetails,
} from '../../../../redux/main/main.actions';
import { showNotify } from '../../../../redux/notify/notify.actions';
import './DiagramGrid.scss';
import { timeAgo } from '../../../../utils/time-ago';

function getDbName(db = '') {
    switch (db) {
        case 'basicsql':
            return 'Basic SQL';
        case 'mysql':
            return 'MySQL';
        case 'postgres':
        case 'postgresql':
            return 'PostgreSQL';
        case 'sqlserver':
            return 'SQL Server';
        case 'oracle':
            return 'Oracle';
        case 'sqlite':
            return 'SQLite';
        case 'snowflake':
            return 'Snowflake';
        case 'mariadb':
            return 'MariaDB';
        default:
            return 'Basic SQL';
    }
}

function DiagramGrid({ data: { id, title, description, db_engine, access_role, archived, updated_at } }) {
    const history = useHistory();
    const dispatch = useDispatch();

    const ref = useRef(null);
    const [isOptionsHovered, setIsOptionsHovered] = useState(false);
    const [isOptionsClicked, setIsOptionsClicked] = useState(false);

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsOptionsHovered(false);
                setIsOptionsClicked(false);
            }
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, []);


    const handleMenuItemClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOptionsClicked(false);
    };


    const handleCloneDiagramClick = (e) => {
        dispatch(toggleModalDiagramClone('main', id));
        handleMenuItemClick(e);
    };

    const handleRenameDiagramClick = (e) => {
        dispatch(toggleModalDiagramRename(id));
        handleMenuItemClick(e);
    };

    const handleSoftDeleteDiagramClick = (e) => {
        dispatch(toggleModalDiagramSoftDelete('main', id));
        handleMenuItemClick(e);
    };

    const handleDeleteDiagramClick = (e) => {
        dispatch(toggleModalDiagramDelete(id));
        handleMenuItemClick(e);
    };

    const handleRestoreDiagramClick = (e) => {
        dispatch(toggleModalDiagramRestore(id));
        handleMenuItemClick(e);
    };

    const handleShareDiagramClick = (e) => {
        dispatch(toggleModalDiagramShare('main', id));
        handleMenuItemClick(e);
    };

    const handleDiagramDetailsClick = (e) => {
        dispatch(toggleDiagramDetails('main', id));
        handleMenuItemClick(e);
    };

    const handleCopyDiagramLinkClick = async (e) => {
        const baseUrl = window.location.origin;
        const path = `/diagram/${id}`;
        const fullUrl = `${baseUrl}${path}`;

        try {
            await navigator.clipboard.writeText(fullUrl);
            dispatch(showNotify({ message: 'The link has been copied' }));
        } catch (err) {
            // console.error("error:", err);
        }

        handleMenuItemClick(e);
    };

    const handleMenuClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleOpenDiagram = (e) => {
        e.preventDefault();
        history.push(`/diagram/${id}`);
    };


    return (
        <a
            // ref={ref}
            className='diagram diagram-grid'
            href={`/diagram/${id}`}
            onMouseEnter={() => { setIsOptionsHovered(true); }}
            onMouseLeave={() => { setIsOptionsHovered(false); setIsOptionsClicked(false); }}
            onClick={(e) => { handleOpenDiagram(e); }}
        >

            <div className="diagram-labels">
                <div className={`diagram-db-engine ${db_engine}`}>{getDbName(db_engine)}</div>
                {access_role !== 'own' ? <div className="diagram-db-engine shared">Shared with me</div> : ''}
                {archived ? <div className="diagram-db-engine archived">Archived</div> : ''}
            </div>


            <div className='diagram-title'>{title}</div>
            {/* <div className='diagram-description'>{description}</div> */}

            <div className="diagram-meta-data-wrap">
                <div className='diagram-meta-data-group'>
                    <div className="diagram-meta-data-item">
                        <svg className="icon-table-group-new" width="30px" height="32px" viewBox="0 0 256 256" fill="none" strokeWidth="10" stroke="#ffffff"><g> <path d="M148,40a4.0002,4.0002,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4.0002,4.0002,0,0,1,148,40Zm-4,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4.00458,4.00458,0,0,1,4,4V71.99951a4,4,0,0,0,8,0V48A12.01375,12.01375,0,0,0,208,36Zm8,71.99951a4.0002,4.0002,0,0,0-4,4v32a4,4,0,0,0,8,0v-32A4.0002,4.0002,0,0,0,216,107.99951Zm0,72a4.0002,4.0002,0,0,0-4,4V208a4.00458,4.00458,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12.01375,12.01375,0,0,0,12-12V183.99951A4.0002,4.0002,0,0,0,216,179.99951Zm-176-32a4.0002,4.0002,0,0,0,4-4v-32a4,4,0,1,0-8,0v32A4.0002,4.0002,0,0,0,40,147.99951ZM72,212H48a4.00458,4.00458,0,0,1-4-4V183.99951a4,4,0,0,0-8,0V208a12.01375,12.01375,0,0,0,12,12H72a4,4,0,0,0,0-8ZM72,36H48A12.01375,12.01375,0,0,0,36,48V71.99951a4,4,0,0,0,8,0V48a4.00458,4.00458,0,0,1,4-4H72a4,4,0,0,0,0-8Z"></path> </g></svg><span>2</span>
                    </div>
                    <div className="diagram-meta-data-item">
                        <svg className="icon-table-box" width="200px" height="200px" viewBox="0 0.5 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_iconCarrier"> <path d="M4 12L20 12M12 4L12 20M6.2 20H17.8C18.9201 20 19.4802 20 19.908 19.782C20.2843 19.5903 20.5903 19.2843 20.782 18.908C21 18.4802 21 17.9201 21 16.8V7.2C21 6.0799 21 5.51984 20.782 5.09202C20.5903 4.71569 20.2843 4.40973 19.908 4.21799C19.4802 4 18.9201 4 17.8 4H6.2C5.0799 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.07989 3 7.2V16.8C3 17.9201 3 18.4802 3.21799 18.908C3.40973 19.2843 3.71569 19.5903 4.09202 19.782C4.51984 20 5.07989 20 6.2 20Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg><span>14</span>
                    </div>
                    <div className="diagram-meta-data-item">
                        <svg className="icon-note" width="28px" height="30px" viewBox="-1.5 -0.5 33 25" strokeWidth="1.1"><g><path d="M 11.5 12 M 27.5 6 V 19.5858 a 1.4903 1.4903 0 0 1 -0.4394 1.0607 l -6.4141 6.4142 A 1.4902 1.4902 0 0 1 19.5858 27.5 H 6 a 1.5017 1.5017 0 0 1 -1.5 -1.5 V 1 A 1.5017 1.5017 0 0 1 6 -0.5 H 26 A 1.5017 1.5017 0 0 1 27.5 1 Z M 6 26.5 H 19.5 V 20 a 0.5 0.5 0 0 1 0.5 -0.5 h 6.5 V 1 a 0.5006 0.5006 0 0 0 -0.5 -0.5 H 6 a 0.5006 0.5006 0 0 0 -0.5 0.5 V 26 A 0.5006 0.5006 0 0 0 6 26.5 Z m 19.7939 -6.001 H 20.5 v 5.2938 Z"></path></g></svg><span>3</span>
                    </div>
                </div>
                <div className="diagram-edit-date">{timeAgo(updated_at)}</div>
            </div>

            {isOptionsHovered ?
                <button
                    type="button"
                    className={`element-button options visible ${isOptionsClicked ? 'clicked' : ''}`}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsOptionsClicked((state) => !state);
                    }}
                >
                    <svg height="28px" width="28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 488" fill="#000000">
                        <g>
                            <circle cx="51.2" cy="244" r="50"></circle>
                            <circle cx="244" cy="244" r="50"></circle>
                            <circle cx="436.8" cy="244" r="50"></circle>
                        </g>
                    </svg>
                </button>
                : ''
            }
            {isOptionsClicked && (
                <div className={`profile-menu ${archived ? 'archived' : ''}`} onClick={(e) => { handleMenuClick(e); }} >
                    {
                        !archived ?
                            <React.Fragment>
                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleDiagramDetailsClick(e); }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"></path></svg>
                                        See details
                                    </button>
                                </div>

                                <div className="horizontal-line"></div>

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => {
                                            handleMenuItemClick(e);
                                            window.open(`/diagram/${id}`, '_blank');
                                        }}
                                    >
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14"></path></svg>
                                        Open in new tab
                                    </button>
                                </div>

                                <div className="horizontal-line"></div>

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleRenameDiagramClick(e); }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z"></path></svg>
                                        Rename
                                    </button>
                                </div>


                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleCloneDiagramClick(e); }}
                                    >
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"><path d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"></path></svg>
                                        Duplicate
                                    </button>
                                </div>

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleShareDiagramClick(e); }}
                                    >
                                        {/* <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15"></path></svg> */}
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7 11C6.07003 11 5.60504 11 5.22354 11.1022C4.18827 11.3796 3.37962 12.1883 3.10222 13.2235C3 13.605 3 14.07 3 15V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15C21 14.07 21 13.605 20.8978 13.2235C20.6204 12.1883 19.8117 11.3796 18.7765 11.1022C18.395 11 17.93 11 17 11M16 7L12 3M12 3L8 7M12 3V15"></path></svg>
                                        Share
                                    </button>
                                </div>

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => {
                                            handleCopyDiagramLinkClick(e);
                                        }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994"></path></svg>
                                        Copy diagram link
                                    </button>
                                </div>

                                <div className="horizontal-line"></div>

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleSoftDeleteDiagramClick(e); }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"></path></svg>
                                        Delete
                                    </button>
                                </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {/* <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleDiagramDetailsClick(e); }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"></path></svg>
                                        See details
                                    </button>
                                </div>

                                <div className="horizontal-line"></div> */}

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleRestoreDiagramClick(e); }}
                                    >
                                        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15"></path></svg>
                                        Restore
                                    </button>
                                </div>

                                <div className="horizontal-line"></div>

                                <div className="control">
                                    <button
                                        className={`control-button`}
                                        type="button"
                                        title=""
                                        aria-label="Color"
                                        aria-pressed="false"
                                        onClick={(e) => { handleDeleteDiagramClick(e); }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"></path></svg>
                                        Permanently delete
                                    </button>
                                </div>
                            </React.Fragment>

                    }

                </div>





                // <ul className="element-button-options-menu">
                //     <li className='element-button-options-menu-item'>
                //         <button
                //             type="button"
                //             className="element-button-options-menu-item-btn"
                //             onClick={(e) => { handleImportSql(e); }}
                //         >
                //             Import SQL
                //         </button>
                //     </li>
                //     <li className='element-button-options-menu-item'>
                //         <button
                //             type="button"
                //             className="element-button-options-menu-item-btn"
                //             onClick={(e) => { handleImportDbml(e); }}
                //         >
                //             Import DBML
                //         </button>
                //     </li>
                // </ul>
            )}
        </a>
    );
}


export default DiagramGrid;
